export const GET_LOCATION = `
  {
    getGeoLocation{
     location
    }
  }
`;
